import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "const";
import UserHelper from "helpers/UserHelper";
import { navigateToNextPosStep } from "helpers/NavigationHelper";

const AuthRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!UserHelper.isLoggedIn()) {
      navigate(ROUTES.LOGIN, { replace: true });
      return;
    }

    navigateToNextPosStep(navigate, { replace: true });
  }, [navigate]);

  return null;
};

export default AuthRedirect;
